(() => {
  if (customElements.get('read-more')) return;

  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
      this.onResize = this.onResize.bind(this);
      this.checkClamp = this.checkClamp.bind(this);
      this.observer = null;
    }

    connectedCallback() {
      this.text = this.querySelector('[data-readmore-text]');
      this.btnMore = this.querySelector('[data-readmore-more]');
      this.btnLess = this.querySelector('[data-readmore-less]');
      
      if (!this.text || !this.btnMore || !this.btnLess) return;

      this.btnMore.addEventListener('click', this.onToggle);
      this.btnLess.addEventListener('click', this.onToggle);
      
      window.addEventListener('resize', this.onResize);
      
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(() => {
          if (!this.text.classList.contains('expanded')) {
            this.checkClamp();
          }
        });
        this.observer.observe(this.text);
      }
      
      setTimeout(() => this.checkClamp(), 0);
    }

    disconnectedCallback() {
      if (this.btnMore) {
        this.btnMore.removeEventListener('click', this.onToggle);
      }
      if (this.btnLess) {
        this.btnLess.removeEventListener('click', this.onToggle);
      }
      window.removeEventListener('resize', this.onResize);
      
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    isClamped() {
      return this.text.scrollHeight > this.text.clientHeight + 1;
    }

    checkClamp() {
      if (this.text.classList.contains('expanded')) {
        this.btnMore.style.display = 'none';
        this.btnLess.style.display = 'inline';
        return;
      }

      if (this.isClamped()) {
        this.btnMore.style.display = 'inline';
        this.btnLess.style.display = 'none';
      } else {
        this.btnMore.style.display = 'none';
        this.btnLess.style.display = 'none';
      }
    }

    onToggle() {
      const expanded = this.text.classList.toggle('expanded');
      this.checkClamp();
    }

    onResize() {
      if (!this.text.classList.contains('expanded')) {
        this.checkClamp();
      }
    }
  }

  customElements.define('read-more', ReadMore);

  const initReadMore = () => {
    document.querySelectorAll('read-more').forEach(el => {
      if (el.text && el.btnMore && el.btnLess) {
        el.checkClamp();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initReadMore);
  document.addEventListener('shopify:section:load', initReadMore);
})();
